<template>
   <svg width="27" height="24" viewBox="0 0 27 24" xmlns="http://www.w3.org/2000/svg">
     <path d="M1.46 14.84a3.45 3.45 0 015.44-2.82.73.73 0 10.84-1.2 4.88 4.88 0 00-4.53-.57A4.83 4.83 0 017.6 3.4a4.85 4.85 0 014.84 4.85.73.73 0 101.46 0c0-1.99-.92-3.75-2.35-4.91a4.85 4.85 0 018.4 4.56v.03c-.02.05-.02.1-.02.15l-.01.13c0 .05.02.09.03.13l.05.14.08.1.1.11.02.03a2.6 2.6 0 011.05 2.1l-.02.2c-8 .76-13.1 3.28-16.57 7.24a3.44 3.44 0 01-3.21-3.42m25.15-4.05c-1.38 0-2.66.05-3.9.13l.01-.1a4.1 4.1 0 00-1.25-2.94 6.3 6.3 0 00-11.14-5.31 6.3 6.3 0 00-8.39 8.4 4.89 4.89 0 001.7 8.58 23.59 23.59 0 00-2.3 3.87c13.67 0 20.25-1.93 24.3-6.8-1.46-.2-2.85-.29-4.2-.3a35.08 35.08 0 005.17-5.53"/>
   </svg>
</template>

<script>
export default {
   name: 'CottonIcon'
}
</script>